module.exports = __webpack_public_path__ + "img/effects-1.b507a6dd.png";